module.exports = __webpack_public_path__ + "static/media/SAM_1079.d58a9f85.JPG";